<template>
  <div>
    <v-btn color="green" dark
      ><v-icon>mdi-file-excel-box</v-icon>
      <download-excel
        type="xls"
        name="Plan de pagos"
        :data="(FinancialMode)?comp_planPagosFinancial:comp_planPagos"
      >
        Exportar a Excel
      </download-excel>
    </v-btn>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Pago</th>
            <th class="text-left">Monto</th>
            <!--<th class="text-left">Interes</th>
            <th class="text-left">Amortización</th>-->
            <th class="text-left">Saldo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in (FinancialMode)?comp_planPagosFinancial:comp_planPagos" :key="item.pago">
            <td>Pago {{ item.pago }}</td>
            <td>
              {{ $pgsHelper.formatNumber(item.cantidad) }}
            </td>
          <!-- <td>
              {{ $pgsHelper.formatNumber(item.interes) }}
            </td>
            <td>
              {{ $pgsHelper.formatNumber(item.amortizacion) }}
            </td>-->
            <td>{{ $pgsHelper.formatNumber(item.saldo) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<style scoped></style>

<script>
import MembresiaClass from "../../../clases/Membresias/Membresia.js";
import MembresiaPlan from "../../../clases/Membresias/MembresiaPlan.js";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
import Currency from "../../../clases/Currencies.js";
export default {
  name: "TablaPlanPagos",
  components: {},
  props: ["Membresia","FinancialMode","periodos","montoInicial","tia"],
  data() {
    return {
      numeroPeriodos:12,
    };
  },
  methods: {

  },
  computed: {
    comp_planPagos() {
      let NPeriodos = PeriodosCobro.getById(this.Membresia.Periodo).Pagos;
      let pagos   = [];
      let nPagos  = NPeriodos;
      let interes = 0 / 100 / nPagos //this.Membresia.PlanE.TIA / 100 / nPagos;
      let montoInicial = this.Membresia.Plan ? Currency.getExchangeRateByCurrency(this.Membresia.PlanE.CA.C,this.Membresia.PlanE.CA.M,Currency.getCurrencyDefault()) : 0;
      let saldo = montoInicial;

      for (let index = 1; index <= nPagos; index++) {
        //calculo del pago por periodo
        let montoPagoPeriodo =(interes>0)?
          (montoInicial * interes) / (1 - Math.pow(1 + interes, 0 - nPagos)):
          montoInicial/nPagos;
        //calculo de intereses del periodo
        let interesPeriodo = saldo * interes;
        //  calculo de amortizacion por periodo
        let amortizacion = montoPagoPeriodo - interesPeriodo;
        // calculo del saldo
        saldo = saldo - amortizacion;
        pagos.push({
          pago: index,
          cantidad: parseFloat(montoPagoPeriodo).toFixed(2),
          interes: parseFloat(interesPeriodo).toFixed(2),
          amortizacion: parseFloat(amortizacion).toFixed(2),
          saldo: parseFloat(saldo).toFixed(2),
          plan: this.Membresia.Plan,
        });
        let test = 0 + 45;
        test; //?
      }


      return pagos;
    },
    comp_planPagosFinancial(){
      let NPeriodos = this.periodos;
      let pagos   = [];
      let nPagos  = NPeriodos;
      let interes = this.tia / 100 / nPagos //this.Membresia.PlanE.TIA / 100 / nPagos;
      let montoInicial = Currency.getExchangeRateByCurrency(this.montoInicial,"MXN",Currency.getCurrencyDefault());
      let saldo = montoInicial;

      for (let index = 1; index <= nPagos; index++) {
        //calculo del pago por periodo
        let montoPagoPeriodo =(interes>0)?
          (montoInicial * interes) / (1 - Math.pow(1 + interes, 0 - nPagos)):
          montoInicial/nPagos;
        //calculo de intereses del periodo
        let interesPeriodo = saldo * interes;
        //  calculo de amortizacion por periodo
        let amortizacion = montoPagoPeriodo - interesPeriodo;
        // calculo del saldo
        saldo = saldo - amortizacion;
        pagos.push({
          pago: index,
          cantidad: parseFloat(montoPagoPeriodo).toFixed(2),
          interes: parseFloat(interesPeriodo).toFixed(2),
          amortizacion: parseFloat(amortizacion).toFixed(2),
          saldo: parseFloat(saldo).toFixed(2),
          //plan: this.Membresia.Plan,
        });
        let test = 0 + 45;
        test; //?
      }


      return pagos;
    }
  },
  beforeMount: async function () {
  },
  mounted() {
  },
  watch: {},
};
</script>
